// price type IDs
export const PURCHASE = 1; // price_purchase
export const PURCHASE_PER_LITER = 2; // price_purchase_per_liter
export const SELL = 3; // price_sell
export const SELL_PER_LITER = 4; // price_sell_per_liter
export const SURCHARGE = 5; // price_surcharge
export const DISCOUNT = 6; // price_discount
export const VAT = 7; // price_vat
export const PRICE_GROUP_TYPE = 8; // price_price_group
export const PURCHASE_PRICE_GROUP_PER_LITER = 9; // price_purchase_pg_per_liter
export const NUMBER_OF_PRICE_GROUPS = 10; // num_price_groups
export const COST = 11; // price_cost
export const COST_PER_LITER = 12; // price_cost_per_liter
export const PURCHASE_PER_KILOGRAM = 13; // price_purchase_per_kilogram
export const PURCHASE_PG_PER_KILOGRAM = 14; // price_purchase_pg_per_kilogram
export const SELL_PER_KILOGRAM = 15; // price_sell_per_kilogram
export const COST_PER_KILOGRAM = 16; // price_cost_per_kilogram

export const POS_COEFICIENT = 19;
export const PRICE_GROUP_NAME = 20;

export const MARGIN_TYPE_MARGIN = 1;
export const MARGIN_TYPE_DISCOUNT = 2;
export const MARGIN_TYPE_MARKUP = 3;

export const VALUE_TYPE_ABSOLUTE = 1;
export const VALUE_TYPE_PERCENT = 2;
export const VALUE_TYPE_NUM_OF_ITEMS = 3;

// calculated price types
export const BASE_PURCHASE = "base_purchase";
export const BASE_SELL_FULL = "base_sell_full";
export const BASE_SELL = "base_sell";
export const CNT_PURCHASE = "cnt_purchase";
export const CNT_PURCHASE_BY_NAME = "cnt_purchase_by_name";
export const CNT_SELL_FULL = "cnt_total_sell_full";
export const CNT_SELL_FULL_BY_NAME = "cnt_sell_full_by_name";
export const CNT_SELL = "cnt_total_sell";
export const CNT_SELL_BY_NAME = "cnt_sell_by_name";
export const MARGIN_ALL = "margin_all";
export const MARGIN_PER_PKG = "margin_per_pkg";
export const PRICE_GROUP = "price_group";
export const PRICE_GROUP_BARCODE = "price_group_barcode";
export const PRICE_GROUP_NAME_TEXT = "price_group_name";
export const SELL_PRICE_ALL = "sell_price_all";
export const SELL_PRICE_PER_L = "sell_price_per_l";
export const SELL_PRICE_PER_KG = "sell_price_per_kg";
export const SELL_PRICE_PER_PKG = "sell_price_per_pkg";
export const SURCHARGE_ALL = "surcharge_all";
export const SURCHARGE_PER_PKG = "surcharge_per_pkg";
export const TINT_PURCHASE_ALL = "tint_purchase_all";
export const TINT_PURCHASE_PER_PKG = "tint_purchase_per_pkg";
export const TINT_SELL_FULL_ALL = "tint_sell_full_all";
export const TINT_SELL_FULL_PER_PKG = "tint_sell_full_per_pkg";
export const TOTAL_PURCHASE_ALL = "total_purchase_all";
export const TOTAL_PURCHASE_PER_L = "total_purchase_per_l";
export const TOTAL_PURCHASE_PER_KG = "total_purchase_per_kg";
export const TOTAL_PURCHASE_PER_PKG = "total_purchase_per_pkg";
export const TOTAL_SELL_FULL_ALL = "total_sell_full_all";
export const TOTAL_SELL_FULL_PER_L = "total_sell_full_per_l";
export const TOTAL_SELL_FULL_PER_KG = "total_sell_full_per_kg";
export const TOTAL_SELL_FULL_PER_PKG = "total_sell_full_per_pkg";

export const PACKAGE_PURCHASE = "package-purchase";
export const PACKAGE_VAT = "package-vat";
export const PACKAGE_SURCHARGE = "package-surcharge";
export const PACKAGE_MARGIN = "package-margin";
